<cs-icon-button
  class="btn-back"
  iconType="icon"
  icon="fi-arrow-left"
  color="secondary"
  size="12"
  (buttonClick)="goBack()"
></cs-icon-button>
<div class="heading">SAVE A NEW ADDRESS</div>
<div class="cont">
  <div class="wrap">
    <div class="row">
      <div class="item">
        <cs-input
          [label]="'Choose a name for this address'"
          [placeholder]="''"
          [suffixText]="remarkLengthText"
          [(value)]="remark"
          [maxLength]="remarkMaxLength"
          (valueChange)="onRemarkChange()"
          [marginBottom]="'0px'"
          [hasError]="!remarkValid.valid"
          [errorHint]="remarkValid.text"
        />
      </div>
    </div>
    <div class="row">
      <!-- 選擇網路 -->
      <div class="item">
        <div class="label">
          <span>Select network</span>
        </div>
        <cs-select
          [(value)]="selectedNetwork"
          [options]="networkList"
          [disabled]="address.trim().length > 0"
          (valueChange)="networkChange()"
        ></cs-select>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <cs-input
          [label]="'Enter your address'"
          [placeholder]="''"
          [hasError]="!addressValid.valid"
          [errorHint]="addressValid.text"
          [disabled]="false"
          [marginBottom]="'0px'"
          [(value)]="address"
          (valueChange)="onAddressChange()"
        />
      </div>
    </div>
  </div>
  <cs-button
    label="Add to my saved addresses"
    [disabled]="!canSubmit()"
    color="third"
    size="large"
    (buttonClick)="submit()"
  ></cs-button>
</div>
